import {
  PRICE_ASC,
  PRICE_ASC_NAME,
  PRICE_DESC,
  PRICE_DESC_NAME,
  POPULARITY,
  POPULARITY_NAME,
  NEWEST_FIRST,
  NEWEST_FIRST_NAME,
  SORT_NAME_MAP,
  DISCOUNT_DESC_NAME,
  DISCOUNT_DESC,
} from '@/store/consts';

export default {
  props: {
    value: {
      type: String,
      required: true,
    }
  },

  computed: {
    selectValue() {
      return SORT_NAME_MAP[this.value];
    },
    options() {
      return [
        {
          name: PRICE_DESC_NAME,
          value: PRICE_DESC,
        },
        {
          name: PRICE_ASC_NAME,
          value: PRICE_ASC,
        },
        {
          name: DISCOUNT_DESC_NAME,
          value: DISCOUNT_DESC,
        },
        {
          name: POPULARITY_NAME,
          value: POPULARITY,
        },
        {
          name: NEWEST_FIRST_NAME,
          value: NEWEST_FIRST,
        },
      ]
    }
  },

  methods: {
    onChange({ value }) {
      this.$emit('sort-change', value);
    }
  }
}